import React from 'react';
import DynamicIcon from './dynamic-icon';
import ComingSoonText from './coming-soon-text';

const DropdownOptionItem = ({ children, onClick, additionalclasses, isDisabled, icon, tag, description, isActive, secondaryIcon, iconSize, secondaryIconClick }) => {
    return (
        <div
            onClick={!isDisabled ? onClick : undefined}
            className={`${isDisabled ? 'cursor-not-allowed' : 'cursor-pointer'} dropdown-option flex items-center gap-[12px] justify-between px-[16px] m-auto w-[98%] py-[8px] w-full hover:bg-grey-50 dark:hover:bg-white-dark-200 leading-[21px] poppins-regular text-[14px] custom-text-grey-900 hover:custom-text-grey-500 rounded-[8px] ${additionalclasses}`}
        >
            <div className='grid gap-[2px]'>
                <div className='flex justify-between items-center gap-[4px]'>
                    <div className='flex items-center gap-[8px] justify-start'>
                        {icon && <DynamicIcon name={icon} size={18} />}
                        {children}
                    </div>
                    {tag && <ComingSoonText>{tag}</ComingSoonText>}
                </div>
                {description && <span className='text-[12px] custom-text-grey-400 poppins-regular leading-[16px] whitespace-nowrap'>{description}</span>}
            </div>
            {secondaryIcon && <DynamicIcon name={secondaryIcon} size={iconSize} onClick={() => { secondaryIconClick() }} />}
            {isActive && <DynamicIcon name='check' size={18} />}
        </div>
    );
};


export default DropdownOptionItem;